import React from 'react';
import './VisitModalHeader.css';

/**
 * Shared header for visit modals (Generate Visit Letter, Confirm PI Availability, etc.)
 * Displays Project, Site, and PI (Investigator) in a centered row.
 */
const VisitModalHeader = ({ projectCode, siteName, siteCode, piName }) => {
  const siteDisplay = siteCode || siteName || '-';
  const piDisplay = piName && piName.trim() ? piName.trim() : '-';
  const projectDisplay = projectCode && projectCode.trim() ? projectCode.trim() : '-';

  return (
    <div className="visit-modal-header">
      <div className="visit-modal-header-row">
        <span><strong>Project:</strong> {projectDisplay}</span>
        <span><strong>Site:</strong> {siteDisplay}</span>
        <span><strong>PI Name:</strong> {piDisplay}</span>
      </div>
    </div>
  );
};

export default VisitModalHeader;
